import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const wpColumns = () => {

    let dir = false;
    const columns = document.querySelectorAll('.wp-block-columns.is-marquee-left');
    
    if (!columns.length) return;

    columns.forEach(column => {
        // Wrap column in swiper div
        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper';
        swiperWrapper.className = 'marquee-left';
        column.parentNode.insertBefore(swiperWrapper, column);
        swiperWrapper.appendChild(column);
        
        // Add swiper-wrapper class to column
        column.classList.add('swiper-wrapper');

        // Add swiper-slide class to all wp-block-column elements
        const columnElements = column.querySelectorAll('.wp-block-column');
        columnElements.forEach(col => {
            col.classList.add('swiper-slide');
        });

        // Check if the slider element is valid and has the required structure
        if (!swiperWrapper || !swiperWrapper.querySelector('.swiper-wrapper')) return;

        const swiper = new Swiper(swiperWrapper, {
            slidesPerView: 4,
            spaceBetween: 60,
            loop: true,
            speed: 12000,
            allowTouchMove: false,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: dir
            }
        });

        dir = dir ? false : true;
    });
}